// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  inviteId: __t.u64().primaryKey().name("invite_id"),
  orgId: __t.u64().name("org_id"),
  email: __t.string(),
  role: __t.string(),
  inviteToken: __t.string().name("invite_token"),
  createdAt: __t.i64().name("created_at"),
  acceptedAt: __t.i64().name("accepted_at"),
});
